module.exports = __webpack_public_path__ + "media/18.9827c7b4.mp3";